export enum ProductEvents {
  ProductClicked = 'Product Clicked',
  ProductListViewed = 'Product List Viewed',
  ProductListFiltered = 'Product List Filtered',
  ProductAdded = 'Product Added',
  PLAListViewed = 'PLA List Viewed',
  PLAListFiltered = 'PLA List Filtered',
  ProductViewed = 'Product Viewed',
  ProductAddedToWishlist = 'Product Added To Wishlist',
  WishlistButtonClicked = 'Wishlist Button Clicked',
  ProductCheckInstallments = 'Check Installments',
  ProductInteraction = 'product_interaction',
  ProductModularDetail = 'module_detail',
  ProductSetsDetail = 'set_item_detail',
  ProductDetail = 'ProductDetail',
  AddToCart = 'AddToCart',
  ProductRemoveFromCart = 'RemoveFromCart',
  ProductShowCaseSelection = 'showcase_selection',
  ProductBoughtTogether = 'BoughtTogether',
  ProductBoughtTogetherClick = 'click_buy_together_product',
  ListView = 'ListView',
  ListFilter = 'ListFilter',
  ProductClick = 'ProductClick',
  ProductExtendedWarranty = 'product_extend_warranty',
  OnDemandProductView = 'OnDemandProductView',
  OnDemandAddToCart = 'OnDemandAddToCart',
  OnDemandConversion = 'OnDemandConversion',
  PurchaseAllView = 'PurchaseAllView',
}

export enum ProductInteraction {
  ImageArrows = 'image_arrows',
  ImageGalleryArrows = 'image_gallery_arrows',
  ImageSelect = 'image_select',
  ThumbSelect = 'thumbnail_select',
  VariantSelect = 'variant_select',
  ItemIncrease = 'item_increase',
  ItemDecrease = 'item_decrease',
  ManualShippingCalc = 'manual_shipping_calc',
  AutomaticShippingCalc = 'automatic_shipping_calc',
  PartnerShippingCalc = 'partner_shipping_calc',
  ChangeWarranty = 'change_warranty',
  CheckboxWarranty = 'checkbox_warranty',
  HyperlinkRatings = 'hyperlink_ratings',
  HyperlinkProductInformation = 'hyperlink_product_information',
  ProductDescriptionTab = 'product_description_tab',
  ProductInformationTab = 'product_information_tab',
  ProductRatingsTab = 'product_ratings_tab',
  ProductQuestionsTab = 'product_questions_tab',
  ExtendedWarrantyTab = 'extended_warranty_tab',
  SetItemDetail = 'set_item_detail',
  ViewSetItemDetail = 'view_set_item_detail',
  WhatsappNotification = 'whatsapp_notification',
  PaymentOption = 'payment_option',
  ProductInteractionWarranty = 'product_interaction_warranty',
  HowToBuy = 'how_to_by',
  HowToCalculate = 'how_to_calculate',
  ProductModularDetail = 'module_detail',
  IncreaseModule = 'increase_module_item',
  DecreaseModule = 'decrease_module_item',
  ViewModuleItemDetail = 'view_module_detail',
  ClickWarranty = 'click_warranty',
  PaymentOptionDetail = 'payment_option_detail',
  FractionalCalculator = 'fractional_calculator',
  Share = 'share',
  SendQuestion = 'send_question',
  CallSpecialist = 'call_specialist',
  CtaComponent = 'cta_component',
  SeeAllSellerProducts = 'see_all_seller_products',
  SeeMoreSellerProducts = 'see_more_seller_products',
  Collapse = 'collapse',
  AddMontagem = 'add_montagem',
  AddImpermeabilizacao = 'add_impermeabilizacao',
  PlayVideo = 'play_video',
  GalleryPlayVideo = 'gallery_play_video',
  AssemblyGalleryTab = 'assembly_gallery_tab',
  AssemblyGallerySelect = 'assembly_gallery_select',
  ShowAllCharacteristics = 'features_details',
  ShowAllQuestions = 'questions_details',
  ShowAllRatings = 'ratings_details',
  ShowAllDescription = 'description_details',
  ScrollToTop = 'floating_back_to_top',
  ProductServiceInsertZipcode = 'product_service_insert_zipcode',
  SendOutOfStockAlert = 'send_out_of_stock_alert',
  UnavailableCTA = 'unavailable_cta',
  CouponCopy = 'coupon_copy',
  PendingReviewVisualization = 'pending_review_visualization',
  PendingReviewCloseComponent = 'pending_review_close_component',
  PendingReviewSeeAll = 'pending_review_see_all',
  PendingReviewProductRating = 'pending_review_product_rating',
}
